import { jsx } from 'react/jsx-runtime';
import { createRoutesFromChildren, Route } from 'react-router-dom';

function isReactRouterBeta() {
  const [obj] = createRoutesFromChildren(/* @__PURE__ */ jsx(Route, { index: true, element: /* @__PURE__ */ jsx("div", {}) }));
  return !obj.index;
}

export { isReactRouterBeta };
//# sourceMappingURL=isReactRouterBeta.esm.js.map
